<script>
import requirementTable from "../components/requirements/requirementTable.vue";
import offerTable from "../components/offers/offerTable.vue";
export default {
  name: "dashboard",
  components: { requirementTable, offerTable },
  data: function() {
    return {};
  },
  methods: {},
  computed: {},
  mounted: function() {},
};
</script>

<template>
  <div>
    <requirement-table></requirement-table>
    <offer-table></offer-table>
  </div>
</template>

<style scoped></style>
